import { Tenant } from '@models/module/tenant';
import { TenantSetting } from '@models/tenant';

export type TenantState = {
  settings: TenantSetting[];
  availableTenants: Tenant[];
  selectedTenant: Tenant;
  isLoading: boolean;
  loadingSettings?: boolean;
};

export const initialTenantState: TenantState = {
  settings: [],
  availableTenants: [],
  selectedTenant: null,
  isLoading: false,
  loadingSettings: false,
};

export enum TenantStoreActions {
  SelectTenant = '[Tenant] Select Tenant',
  LoadingSettings = '[Tenant] Loading Settings',
  SetSettings = '[Tenant] Set Settings',
  LoadingTenants = '[Tenant] Loading Tenants',
  SetTenants = '[Tenant] Set Tenants',
  UpdateSetting = '[Tenant] Update Setting',
}
